import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { IconButton } from '@mui/material'
import PageLoading from '../../../components/PageLoading/PageLoading'
import { getAnalisisEncuesta } from '../../../utils/api/encuesta'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import TableHeader from '../../../components/TableHeader/TableHeader'
import InformationTable from '../../../components/Table/InformationTable'
import VersionEncuestaSelector from '../../../components/form/VersionEncuestaSelector/VersionEncuestaSelector'
import ModalDetallesEncuesta from '../../../modals/ModalDetallesEncuesta/ModalDetallesEncuesta'
import { dateToString } from '../../../utils/date'
import { getCSVContent, downloadCSVFile } from '../../../utils/csv'
import css from './Encuesta.module.css'

const Encuesta = () => {
  const notification = useNotification()
  const [version, setVersion] = useState('v1')
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedEncuesta, setSelectedEncuesta] = useState(null)

  const { data: encuestaList = [] } = useQuery({
    queryKey: ['marketing', 'respuesta-encuesta', 'analisis', version],
    queryFn: () =>
      getAnalisisEncuesta(version).catch(err => {
        notification.error({
          title: 'Error al recuperar los datos de encuesta',
          content: err
        })
        return []
      })
  })

  const handleOpenDetallesModal = encuesta => {
    setSelectedEncuesta(encuesta)
    setModalOpen(true)
  }

  const handleCloseDetallesModal = () => {
    setSelectedEncuesta(null)
    setModalOpen(false)
  }

  const handleDownloadCSV = () => {
    const rows = []
    encuestaList.forEach(encuesta => {
      const alumno = encuesta.alumno?.nombre || ''
      const centro = encuesta.centro || ''
      encuesta.cuestionario?.forEach(pregunta => {
        rows.push([
          alumno,
          centro,
          pregunta.pregunta || '',
          pregunta.respuesta || ''
        ])
      })
    })
    const csvContent = getCSVContent({
      columns: ['Alumno', 'Centro', 'Pregunta', 'Respuesta'],
      data: rows
    })
    downloadCSVFile(csvContent, `encuestas_${version}`)
  }

  return (
    <PageLoading>
      <TableHeader
        actions={
          <div className={css.actions}>
            <VersionEncuestaSelector
              name='version'
              label='Version'
              value={version}
              onChange={e => setVersion(e.target.value)}
            />
            <IconButton
              className={css.download}
              size='small'
              color='primary'
              onClick={handleDownloadCSV}
              disabled={!encuestaList || encuestaList.length === 0}
            >
              <i className='material-icons'>download</i>
            </IconButton>
          </div>
        }
        title='Encuestas'
        showSearch={false}
      />
      <InformationTable
        size='small'
        details={[
          { title: 'Alumno', key: 'alumno', align: 'left' },
          { title: 'Academia', key: 'academia', align: 'left' },
          {
            title: 'Profesores',
            key: 'profesor',
            sortDisabled: true,
            align: 'center'
          },
          { title: 'Fecha', key: 'fecha', sortDisabled: true, align: 'center' },
          {
            title: 'Cuestionario',
            key: 'cuestionario',
            sortDisabled: true,
            align: 'center'
          }
        ]}
        data={encuestaList.map(encuesta => {
          return {
            alumno: encuesta.alumno.nombre || '',
            academia: encuesta.centro || '',
            profesor: encuesta.profesores?.length || 0,
            fecha: dateToString(encuesta.fecha),
            cuestionario: (
              <IconButton
                size='small'
                color='warning'
                onClick={() => handleOpenDetallesModal(encuesta)}
                title='Ver cuestionario'
              >
                <i className='material-icons'>assignment</i>
              </IconButton>
            )
          }
        })}
      />
      <ModalDetallesEncuesta
        open={modalOpen}
        encuesta={selectedEncuesta}
        onClose={handleCloseDetallesModal}
      />
    </PageLoading>
  )
}

export default Encuesta
